// extracted by mini-css-extract-plugin
module.exports = {"container":"Card_container__3m4tb","qoutes":"Card_qoutes__1_OIj"};